import { defineMessages } from 'react-intl';

/**
 * The one line on every preview render of the Free plan and the trial (pricing spec 2026-10-08
 * §7.2). The Studio, the asset viewer, the share box, the release assets and the Work page show
 * the same string.
 */
export const previewNoteMessages = defineMessages({
  note: {
    id: 'app.sml.promote.preview.note',
    defaultMessage: 'Free plan preview: low resolution. Upgrade to make it in full quality.',
  },
});
